import "./home.css"
import { readImageFile } from '../../components/readImageFile';
import { uploadMessage } from '../../components/uploadMessage';
import { validateMessage } from "../../components/validateMessage";
import { makeStyles, alpha } from '@material-ui/core/styles'
import { getUser } from "../../service/AuthService";
import { Divider } from '@material-ui/core';
import { Backdrop } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { Link } from "react-router-dom";
// import { FormatBold, FormatItalic } from '@material-ui/icons';
import { TextField, useMediaQuery } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Typography, Grid } from '@material-ui/core';
import { Stack } from '@mui/material';
import PhishTable from '../../components/PhishTable';
import { useState, useEffect } from 'react';
import { Button } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
  
  const styles = makeStyles(theme => ({
    wrapper: {
      margin: "auto",
      textAlign: "center",
      [theme.breakpoints.up('sm')]: {
        width: "95%",
      },
      [theme.breakpoints.up('md')]: {
        width: "90%",
      },
      [theme.breakpoints.up('lg')]: {
        width: "85%",
      },
      [theme.breakpoints.up('xl')]: {
        width: "75%",
      },
    },
    gridStyle: {
      margin: "20px auto",
    },
    bigSpace: {
      marginTop: "5rem"
    },
    littleSpace:{
      textAlign: "left",
      marginLeft: "0.5rem",
      marginTop: "0.5rem",
    },
    smishSubtitle: {
      textAlign: "center",
      marginLeft: "0.5rem",
      marginTop: "0.3rem",
      [theme.breakpoints.up('xs')]: {
        fontSize: "x-small",
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: "small",
      },
      [theme.breakpoints.up('md')]: {
        fontSize: "medium",
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: "medium",
      },
    },
    tabBar:{
      paddingTop: "0.25rem",
      background: "#1976d2",
      '& .MuiTab-textColorInherit.Mui-selected': {
        color: "#F7B905",
      },
    },
    tabItem: {
        cursor: "pointer", 
        color: "inherit",
        fontWeight: "Bold",
        textDecoration: "none",
        "&:hover": {
            color: "#F7B905",
            fontWeight:"bolder",
            backgroundColor: alpha(theme.palette.common.white, 0.10),
        },
    },
    appBarMargins: {
      marginBottom:"8px",
    },
    backdrop: { zIndex: theme.zIndex.drawer + 1, color: '#fff', },
  }));

export default function Home() {
  // const [tabType,setTab]=React.useState(0);
  const classes = styles();
  // const handleTabs=(e,val)=>{
  //   setTab(val)
  // }
  useEffect(() => {
    document.title = "Smishtank: Home"
  }, []);

  const [selectedImageFile, setImageFile] = useState('');
  const [messageImage, setMessageImage] = useState('');
  const isSmallScreen = useMediaQuery("(max-width: 500px)");
  const createPhishUrl = process.env.REACT_APP_CREATE_SMISH_API_URL;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [msgContent, setContent] = useState('');
  let messageStyle = {
    color: 'green',
    fontWeight: 'bold'
  };
  if (error) {
      messageStyle = {
          color: 'red',
          fontWeight: 'bold'
      }
  }

  function imageHandler(image) {
    setMessageImage(image.value);
    setImageFile(image.files[0]);
    if (!image.value) {
        setMessageImage('');
        setImageFile('');
    }
  }

  const submitHandler = async (event) => {
      event.preventDefault();
      if (loading) {
          return;
      }
      setLoading(true);
      
      const validationResult = validateMessage(messageImage, selectedImageFile, msgContent);

      setLoading(validationResult.loading);
      setError(validationResult.error);
      setMessage(validationResult.message);

      if (validationResult.error) {
          return; // Stop execution if validation fails
      }
      const user = getUser();
      const name = user !== 'undefined' && user ? user.username : '';
      try {
          // Read the image file and get the JSON data


          const requestBody = {
              submitName: name,
          }
          if (selectedImageFile !== '') {
              const jsonData = await readImageFile(selectedImageFile);
              requestBody.image = JSON.stringify(jsonData);
          }

          if (msgContent !== '') {
              requestBody.messageContent = msgContent;
          }

          const requestConfig = {
              headers: {
                  'x-api-key': process.env.REACT_APP_API_GATEWAY_KEY,
              }
          }
          const result = await uploadMessage(createPhishUrl, requestBody, requestConfig, selectedImageFile);
          setLoading(false);
          setError(!result.success);
          setMessage(result.message);
      
          if (result.success) {
              setContent("");
              setImageFile("");
              setMessageImage("");
          }

      } catch (error) {
          console.error(error.message);
      }
  }
  
  return (
      <div className="home">
          <div className={classes.wrapper}>
              <Grid className={classes.gridStyle} item xs={11}>
              <form onSubmit={submitHandler} className="insertSmishForm" id="submitSmish">
                <Box
                  sx={{
                    display: 'flex', // Use flexbox to align items horizontally
                    alignItems: 'center',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    paddingLeft: 1,
                    paddingTop: 1,
                    paddingBottom: 1,
                    bgcolor: 'background.paper',
                    color: 'text.secondary',
                    m: { xs: "0.2rem 0.5rem", sm: 1 },
                  }}
                >
                  <Tooltip title="We accept images in png or jpg format.">
                    <Button
                      variant="contained"
                      component="label"
                      className="buttonStyle smish-frontpage-buttons"
                      sx={{
                        width: '150px', // Fixed width for the button
                        minWidth: '0', // Prevents button from growing in size
                      }}
                    >
                      Upload Image
                      <input
                        value={messageImage}
                        type="file"
                        accept="image/jpeg,image/png"
                        placeholder="image path"
                        className="insertMessageImage"
                        onChange={event => imageHandler(event.target)}
                        style={{ display: 'none' }} // Hide file input element itself
                      />
                    </Button>
                  </Tooltip>

                  <Divider orientation="vertical" variant="middle" flexItem />

                  <TextField
                    id="outlined-multiline-static"
                    label={isSmallScreen ? "(Optional) MSG TXT" : "(Optional) Message Text"}
                    value={msgContent}
                    onChange={event => setContent(event.target.value)}
                    fullWidth
                    sx={{
                      flexGrow: 1, // Make the TextField take up the remaining space
                    }}
                  />
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Stack direction="row" spacing={2} sx={{paddingRight: 1}}>
                    <Button type='submit' variant="contained" className="buttonStyle smish-frontpage-buttons" >
                      Submit
                    </Button>
                  </Stack>
                </Box>
                {messageImage && (
                  <div className="messageInfo-Home">
                    <span className="label-align-Home">File:</span> <span className="label-align-File">{messageImage.split('\\').pop()}</span>
                  </div>
                )}
                {message && <p className="label-align-Home" style={messageStyle}>{message}</p>}
              </form>
                {/* <AppBar className={classes.appBarMargins} position="static"> */}
                  {/* <Tabs 
                    variant="fullWidth" 
                    value={tabType} 
                    indicatorColor="secondary"
                    textColor="inherit"
                    onChange={handleTabs}
                    className={classes.tabBar}
                  >
                    <Tab className={classes.tabItem} icon={<Sms />} label="SMS" /> */}
                    {/* <Tab className={classes.tabItem} icon={<Email />} label="Email" /> */}
                    {/* <Tab className={classes.tabItem} icon={<Web />} label="Social Media" /> */}
                  {/* </Tabs>
                </AppBar> */}
                {/* <TabPanel value={tabType} index={0}> */}
                  <PhishTable type="smish"/>
                  {/* </TabPanel> */}
                {/* <TabPanel value={tabType} index={1}><PhishTable type="email"/></TabPanel> */}
                {/* <TabPanel value={tabType} index={2}><PhishTable type="url"/></TabPanel> */}
      
              </Grid>
          </div>
          <Typography variant="h5" color="primary">
                <span>If using data from Smishtank.com, please cite the paper. Citation instructions: <Link to="/dataset" ><span style={{ fontWeight: 'bolder' }}>HERE</span></Link></span><br />
          </Typography>
          <br />
          <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
          </Backdrop>
      </div>
  )
}

// function TabPanel(props)
// {
//   const {children,value,index}=props;
//     return(<div>
//       {
//         value===index && (
//           <span>{children}</span>
//         )
//       }
//     </div>
//     )
// }